import {toNumber} from "./common";

const validateMaxMin = (rule: "max" | "min", value, valueLimit) => {
  if (rule == "max" && toNumber(value) <= toNumber(valueLimit)) {
    return Promise.resolve();
  }
  if (rule == "min" && toNumber(value) >= toNumber(valueLimit)) {
    return Promise.resolve();
  }
  return Promise.reject("");
};
const validateEmail = (_, value) => {
  if (!value || /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Chưa nhập đúng định dạng!"));
};

export {validateMaxMin, validateEmail};
